import { render, staticRenderFns } from "./TaxInput.vue?vue&type=template&id=7c4c4252"
import script from "./TaxInput.vue?vue&type=script&lang=js"
export * from "./TaxInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports